// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.resizable-card[data-v-5d7e958e] {\n  position: relative;\n}\n.resize-handle[data-v-5d7e958e] {\n  position: absolute;\n  right: 4px;\n  bottom: 4px;\n  width: 14px;\n  height: 14px;\n  cursor: se-resize;\n  border-right: 2px solid rgba(0, 0, 0, 0.3);\n  border-bottom: 2px solid rgba(0, 0, 0, 0.3);\n}\n.no-select[data-v-5d7e958e] {\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n}\n", ""]);
// Exports
module.exports = exports;
